import React from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { Add } from '@mui/icons-material';

const MatchDetails = ({ matchDetails, handleMatchChange, startMatch, matchStarted }) => {
  if (matchStarted) {
    return (
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Match Details
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography><strong>Team A:</strong> {matchDetails.teamA}</Typography>
          <Typography><strong>Team B:</strong> {matchDetails.teamB}</Typography>
          <Typography><strong>Date:</strong> {matchDetails.date}</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Box sx={{
      position: 'relative',
      width: '100%',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Paper elevation={3} sx={{
        p: 4,
        maxWidth: 800,
    
        mx: 'auto',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: 3,
        position: 'relative',
        zIndex: 1
      }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img
            src="https://match-videos.s3.ap-south-1.amazonaws.com/emailer-assets/Logo-white.svg"
            alt="StepOut Logo"
            style={{ height: 40, marginBottom: 16 }}
          />
          <Typography variant="h4" component="h2" gutterBottom sx={{ color: 'white' }}>
            Live Match Tagging Portal
          </Typography>
          <Typography variant="subtitle1" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
            One stop portal to tag live events
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Team A Name"
            name="teamA"
            value={matchDetails.teamA}
            onChange={handleMatchChange}
            placeholder="Enter Team A name"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'white',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
              '& .MuiOutlinedInput-input': {
                color: 'white',
              },
            }}
          />
          <TextField
            label="Team B Name"
            name="teamB"
            value={matchDetails.teamB}
            onChange={handleMatchChange}
            placeholder="Enter Team B name"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'white',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
              '& .MuiOutlinedInput-input': {
                color: 'white',
              },
            }}
          />
          <TextField
            label="Match Date"
            name="date"
            type="date"
            value={matchDetails.date}
            onChange={handleMatchChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'white',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255, 255, 255, 0.7)',
              },
              '& .MuiOutlinedInput-input': {
                color: 'white',
              },
              '& input::-webkit-calendar-picker-indicator': {
                filter: 'invert(1)',
              },
            }}
          />
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={startMatch}
            disabled={!matchDetails.teamA || !matchDetails.teamB || !matchDetails.date}
            fullWidth
            sx={{
              mt: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
              },
              '&:disabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: 'rgba(255, 255, 255, 0.5)',
              }
            }}
          >
            Start Match
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default MatchDetails;